import { useState, useRef } from "react";

const Blogs = () => {
  // 👉 Blog data (add more items here)
  const blogs = [
    {
      id: 1,
      title: "How to Find Jobs in Australia",
      description:
        "Finding a job in Australia can be challenging, especially for new job seekers, migrants, or people changing careers. One of the most effective ways to find work is to look beyond traditional job boards and connect directly with local employers. Networking, visiting nearby businesses, and being open to casual or temporary roles can significantly increase your chances. Platforms like Skilled Mates make it easier for employers to find available local workers quickly, without long hiring processes.",
    },
    {
      id: 2,
      title: "Why Am I Not Able to Find a Job in Australia?",
      description:
        "Many job seekers in Australia struggle to find work even after applying for dozens of roles. Common reasons include an unclear or poorly formatted resume, lack of local experience, limited availability, or applying for roles that do not match current market demand. Employers often prioritise candidates who can start immediately and work flexible hours. Skilled Mates helps solve this by allowing employers to search based on availability and location rather than relying only on resumes.",
    },
    {
      id: 3,
      title: "Common Resume Mistakes That Stop You Getting Interviews",
      description:
        "A resume is often the first impression you make on an employer. Common mistakes include using the same resume for every job, including too much irrelevant information, and not highlighting key skills or achievements. Spelling and grammar errors can also reduce your chances of being shortlisted. In Australia, employers prefer clear, simple resumes that show availability and reliability. Skilled Mates also helps workers get noticed by focusing on when and where they are ready to work.",
    },
    {
      id: 4,
      title: "Is the Job Market in Australia Tough Right Now?",
      description:
        "The Australian job market is changing, not disappearing. While some industries are highly competitive, others continue to experience staff shortages, particularly in hospitality, aged care, disability support, cleaning, and construction. Job seekers who are flexible and open to casual or temporary work often find opportunities faster. Skilled Mates connects businesses needing staff urgently with people who are available to work immediately.",
    },
    {
      id: 5,
      title: "Best Way to Find Casual and Part-Time Jobs in Australia",
      description:
        "Casual and part-time jobs are one of the fastest ways to enter the Australian workforce. These roles are common in hospitality, retail, care services, and logistics. Approaching local businesses directly and using platforms designed for quick hiring can significantly improve success. Skilled Mates allows workers to show their availability and helps businesses fill shifts quickly, making it easier for job seekers to find work without long application processes.",
    },
    {
      id: 6,
      title: "How Skilled Mates Helps Businesses Find Staff Faster",
      description:
        "Finding staff at short notice can be challenging for small businesses. Skilled Mates helps employers connect with local workers based on location and availability. This means businesses can quickly fill shifts, reduce downtime, and maintain service quality during busy periods or unexpected staff shortages.",
    },
    {
      id: 7,
      title: "Why Flexible Work Is the Future",
      description:
        "Flexible work is becoming more important for job seekers across Australia. Workers want control over when they work, how many hours they take on, and where they work. Platforms like Skilled Mates empower casual workers to find opportunities that suit their lifestyle while supporting businesses in real time.",
    },
    {
      id: 8,
      title: "Solving Staff Shortages During Peak Seasons",
      description:
        "Public holidays, weekends, and peak seasons place huge pressure on businesses. Having access to a pool of ready-to-work locals allows businesses to stay agile and prepared. Skilled Mates bridges that gap by making staffing simple, fast, and affordable.",
    },
     {
    id: 9,
    title: "How to Prepare for a Job Interview in Australia",
    description:
      "Preparing for a job interview in Australia starts with understanding the company and the role you are applying for. Employers expect candidates to know basic information about their business and to explain how their skills fit the job. Practising common interview questions, dressing appropriately, and arriving on time can make a strong first impression. Being clear about your availability and work rights is also important to Australian employers.",
  },
  {
    id: 10,
    title: "Common Job Interview Mistakes and How to Avoid Them",
    description:
      "Many candidates miss out on jobs due to simple interview mistakes. Arriving late, giving very short or unclear answers, or speaking negatively about previous employers can reduce your chances. In Australia, interviewers value honesty, reliability, and a positive attitude. Preparing real examples from past work or study and showing willingness to learn can help you stand out.",
  },
  {
    id: 11,
    title: "How to Answer Interview Questions Confidently",
    description:
      "Answering interview questions confidently does not mean having perfect English or memorised answers. Employers are more interested in understanding how you think and how you handle situations. Using simple, clear language and giving real examples from your experience can make your answers stronger. Practising answers out loud before the interview can improve confidence and reduce nervousness.",
  },
  {
    id: 12,
    title: "What Australian Employers Look for in Job Interviews",
    description:
      "Australian employers look for more than just qualifications during interviews. Reliability, communication skills, teamwork, and flexibility are highly valued. Being honest about your availability and willingness to take on shifts can significantly improve your chances. Employers also appreciate candidates who ask genuine questions about the role and show interest in long-term opportunities.",
  },
  {
    id: 13,
    title: "How to Pass Your First Job Interview",
    description:
      "Passing your first job interview can feel stressful, but preparation makes a big difference. Focus on explaining your skills, availability, and eagerness to learn rather than worrying about a lack of experience. Many Australian employers are happy to train motivated candidates. Showing up on time, dressing neatly, and maintaining a positive attitude can help you leave a strong impression.",
  },
  {
    id: 14,
    title: "How to Follow Up After a Job Interview",
    description:
      "Following up after a job interview can show professionalism and interest in the role. A short thank-you email within 24 hours is often appreciated by Australian employers. Keep the message polite and simple, thanking them for the opportunity and expressing continued interest. This small step can sometimes make the difference between two equally qualified candidates.",
  },
   {
    id: 15,
    title: "Best Job Search Websites in Australia",
    description:
      "Job seekers in Australia often rely on popular job search websites to find work, but competition on these platforms can be very high. While sites like Seek and Indeed are useful, many jobs are filled before they are advertised publicly. Exploring local hiring platforms, visiting businesses directly, and using services like Skilled Mates can help job seekers find opportunities faster, especially for casual and temporary roles.",
  },
  {
    id: 16,
    title: "How to Get a Job Without Australian Experience",
    description:
      "Lack of Australian experience is one of the most common challenges faced by new migrants and international students. Employers often prioritise local experience, but many are willing to train candidates who show reliability and a positive attitude. Starting with casual roles, volunteering, or short-term work can help build experience quickly. Skilled Mates allows employers to find workers based on availability rather than long work history.",
  },
  {
    id: 17,
    title: "High Demand Jobs in Australia Right Now",
    description:
      "Some industries in Australia continue to experience labour shortages, even during uncertain economic times. Hospitality, disability support, aged care, cleaning services, warehousing, and construction regularly need workers. Job seekers who remain flexible with hours and locations often secure work faster. Platforms like Skilled Mates help match available workers with businesses needing staff urgently.",
  },
  {
    id: 18,
    title: "How to Write a Resume That Australian Employers Like",
    description:
      "Australian employers prefer clear, concise resumes that highlight relevant skills and experience. A strong resume focuses on achievements rather than long job descriptions and clearly shows availability, work rights, and contact details. Avoid unnecessary graphics or excessive length. Keeping your resume tailored to each role greatly improves your chances of getting interviews.",
  },
  {
    id: 19,
    title: "What to Include in a Job Application in Australia",
    description:
      "A complete job application in Australia usually includes a resume and a short cover letter. Employers look for candidates who clearly explain why they are suitable for the role and when they are available to work. Including licences, certifications, and relevant experience can help your application stand out, especially for roles that require immediate staffing.",
  },
  {
    id: 20,
    title: "How to Get Your First Job in Australia",
    description:
      "Getting your first job in Australia can feel intimidating, but many employers are open to hiring beginners. Entry-level roles in hospitality, retail, and services often focus more on attitude and availability than experience. Being proactive, reliable, and open to casual work increases your chances. Platforms like Skilled Mates help first-time job seekers connect with employers quickly.",
  },
  {
    id: 21,
    title: "How to Find Part-Time Jobs While Studying in Australia",
    description:
      "Students in Australia often look for part-time jobs to support their living expenses. Employers value students who can balance work and study commitments and maintain regular availability. Hospitality, retail, and care roles are popular options. Using platforms that allow employers to search by availability, like Skilled Mates, can help students find flexible work faster.",
  },
  {
    id: 22,
    title: "Why Casual Work Can Lead to Permanent Jobs",
    description:
      "Casual work is often seen as temporary, but in Australia it can lead to permanent employment. Many employers prefer to observe a worker’s reliability and performance before offering long-term roles. Showing up consistently, communicating clearly, and being flexible with shifts can improve your chances of being offered permanent work.",
  },
  {
    id: 23,
    title: "How to Stand Out in a Competitive Job Market",
    description:
      "With many people applying for the same roles, standing out in the job market requires more than online applications. Employers value candidates who show initiative, reliability, and clear communication. Being available at short notice and willing to take on shifts can increase your chances. Platforms like Skilled Mates help employers identify workers who are ready to work immediately.",
  },
  {
    id: 24,
    title: "Common Job Search Myths in Australia",
    description:
      "There are many myths about finding work in Australia, such as needing perfect English or years of local experience. In reality, many employers focus on reliability, attitude, and willingness to learn. Understanding what employers truly value can help job seekers avoid frustration and focus on practical ways to secure employment faster.",
  },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 py-10">
      <h1 className="text-4xl font-extrabold text-center mb-10">
        <span className="bg-gradient-to-r from-blue-500 to-indigo-600 bg-clip-text text-transparent">
          Blogs & Updates
        </span>
        <div className="mt-3 h-1 w-24 mx-auto rounded-full bg-gradient-to-r from-blue-500 to-indigo-600" />
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {blogs.map((blog) => (
          <BlogCard
            key={blog.id}
            title={blog.title}
            description={blog.description}
          />
        ))}
      </div>
    </div>
  );
};

const BlogCard = ({ title, description }) => {
  const [expanded, setExpanded] = useState(false);
  const contentRef = useRef(null);

  return (
    <div className="bg-white rounded-xl shadow-md p-6 flex flex-col min-h-[320px]">
      <h3 className="text-xl font-bold mb-3 text-gray-800">{title}</h3>

      {/* Description */}
      <div
        ref={contentRef}
        className="overflow-hidden transition-[height] duration-500 ease-in-out text-gray-700"
        style={{
          height: expanded ? `${contentRef.current?.scrollHeight}px` : "96px",
        }}
      >
        <p>{description}</p>
      </div>

      {/* Push button to bottom */}
      <div className="flex-grow" />

      {/* Read more button */}
      <div className="mt-4 text-center">
        <button
          onClick={() => setExpanded(!expanded)}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full
            bg-gradient-to-r from-blue-500 to-indigo-600
            text-white text-sm font-semibold
            shadow hover:shadow-lg hover:scale-105
            transition-all duration-200"
        >
          {expanded ? "Read less" : "Read more"}
          <span
            className={`transition-transform ${expanded ? "rotate-180" : ""}`}
          >
            ▾
          </span>
        </button>
      </div>
    </div>
  );
};

export default Blogs;
